import React, { Fragment, useMemo } from 'react';
import './index.scss';
import {
    QuestionOperateType,
    QuestionType,
    TemplateType,
    VIEW_MODE,
} from '../../../../interface/multiCapabilityTemplate';
import { IQuestionElementProps } from '../../interface';
import { Radio } from '@umu/umu-design';
import { hideRadioList, questionTypeList } from '../../dataFlow';
import { QuestionInput } from '../questionInput';
import { If } from 'common/src/components';
import { QuestionResource } from '../../../questionResource';
import { lang } from '@umu/ukit-lang';

const defaultAutoSize = {
    minRows: 3,
    maxRows: 6,
};
const QuestionElement = (props: IQuestionElementProps) => {
    const {
        info,
        preCls = 'template-question',
        externalList = [],
        internalList: defaultInternalList = [],
        children,
        mode,
        templateType,
        suffixLabel = '',
        isValid = false,
        onCommunication,
    } = props;
    const isView = mode === VIEW_MODE.VIEW;
    const isEnterprise = templateType === TemplateType.ENTERPRISE;
    const isHideRadio = hideRadioList.includes(info.type) || isView;
    const isParagraph = info.type === QuestionType.PARAGRAPH;
    const placeholder = isParagraph ? lang('请输入段落说明文字') : '';
    const autoSize = isParagraph ? defaultAutoSize : true;
    const internalList = isParagraph ? [] : defaultInternalList;
    const prefixElement = isParagraph && isView ? <span className="prefix-element">{lang('段落说明：')}</span> : '';
    // 企业模版单独处理（只有数值型且数据独立）
    const questionValue = isView ? `${info.title}${suffixLabel ? `(${suffixLabel})` : ''}` : info.title;
    const getCheckIsValid = () => {
        const result: [boolean, string] = [false, ''];

        if (info.type === QuestionType.PARAGRAPH) {
            return result;
        }
        if (!info.title) {
            return [true, lang('请填写问题')];
        }
        if (info.type === QuestionType.RADIO || info.type === QuestionType.CHECKBOX3) {
            const currentList = info?.list || [];
            const options = currentList.filter((item) => item.title);
            const isAccess = options.length >= 2;
            if (options.length !== currentList.length && isAccess) {
                onCommunication(QuestionOperateType.CHANGE_CONFIG, {
                    ...info,
                    list: options,
                });
            }
            return [!isAccess, isAccess ? '' : lang('当前问题至少需要设置两个不同的选项。')];
        }
        return result;
    };
    const [isShowError, errorMsg] = useMemo(() => {
        if (!isValid) {
            return [false, ''];
        }
        return getCheckIsValid();
    }, [isValid, info]);
    return (
        <div className={`${preCls} ${preCls}-element ${isView ? 'view' : 'editor'}`}>
            <If condition={!isEnterprise}>
                <Fragment>
                    <QuestionInput
                        preCls={`${preCls}-input`}
                        value={questionValue}
                        prefix={isParagraph ? '' : `Q${info.index}.`}
                        autoSize={autoSize}
                        className={isParagraph && isView ? 'show-border paragraph' : ''}
                        prefixElement={prefixElement}
                        placeholder={placeholder}
                        externalList={externalList}
                        internalList={internalList}
                        onCommunication={onCommunication}
                    />
                    <If condition={(info?.extend?.resource_arr || [])?.length > 0}>
                        <QuestionResource
                            list={info?.extend?.resource_arr || []}
                            isALlowDelete
                            className="element-source rows-split"
                            onUpdateResourceList={(list) =>
                                onCommunication(QuestionOperateType.CHANGE_CONFIG, {
                                    extend: {
                                        ...info.extend,
                                        resource_arr: list,
                                    },
                                })
                            }
                        />
                    </If>
                    <If condition={isShowError}>
                        <div className="valid-text">{errorMsg}</div>
                    </If>
                    <If condition={!isHideRadio}>
                        <div className={`${preCls}-question-type rows-split`}>
                            <Radio
                                list={questionTypeList}
                                onChange={(type) => onCommunication(QuestionOperateType.CHANGE_CONFIG, { type })}
                                active={Number(info.type)}
                            />
                        </div>
                    </If>
                </Fragment>
            </If>
            {children && <div className={`${preCls}-children-info rows-split`}>{children}</div>}
        </div>
    );
};
export { QuestionElement };
